import { Injectable, ComponentFactoryResolver, ViewContainerRef } from '@angular/core'

@Injectable({
  providedIn: 'root'
})
export class DynamicComponentLoaderService {
  private componentContainerMap: Record<string, { viewContainerRef: ViewContainerRef; componentType: any }> = {}
  private componentQueue: string[] = []

  constructor() {}

  registerComponent(componentKey: string, viewContainerRef: ViewContainerRef, componentType: any): void {
    this.componentContainerMap[componentKey] = { viewContainerRef, componentType }
  }

  loadComponent(componentKey: string): void {
    if (!this.componentQueue.includes(componentKey)) {
      this.componentQueue.push(componentKey)
    }
    if (this.componentQueue.length > 1) {
      return
    }
    this.openComponent(componentKey)
  }

  private openComponent(componentKey: string) {
    const component = this.componentContainerMap[componentKey]
    const viewContainerRef = component?.viewContainerRef
    if (viewContainerRef) {
      viewContainerRef.clear()
      viewContainerRef.createComponent(component.componentType)
    }
  }

  closeComponent(componentKey: string): void {
    const component = this.componentContainerMap[componentKey]
    const viewContainerRef = component?.viewContainerRef
    if (viewContainerRef) {
      viewContainerRef.clear()
    }
    const index = this.componentQueue.findIndex(v => v === componentKey)
    this.componentQueue.splice(index, 1)

    if (this.componentQueue.length > 0) {
      this.openComponent(this.componentQueue[0])
    }
  }
}
